import color from "../../../../../constants/color";

const style = {
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: 3.5
  },
  crossIcon: {
    mx:1.5,
  },

  leaveHeading: {
    fontWeight: 600,
    fontSize: "20px",
  },
  dropDownMenu: {
    fontSize: "14px",
    fontWeight: "400"
  },
  gridContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  labels: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mb: 1
  },

  dropdown: {
    // width:{ xs: "25em", md: "35em" },
    width: "100%",
    p: 0,
    ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      p: 1
    }
  },

  table: {
    border: "1px solid rgba(224, 224, 224, 1)",
    mt: 2,
    borderRadius: "10px"

  },
  tabledata: {
    border: 0
  },
  dropdowns: {
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "10px 14px",
    },
    // width:{ xs: "25em", md: "35em" },
    width: "100%",
    fontSize: "14px",
    fontWeight: "400",
    mt: 1,
    borderRadius: "10px"
  },
  jobButton: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "12px",
    mt: 1,
  },

  gridbioBox: {
    backgroundColor: "#ffff",
    m: 3,
    p: 3,
    mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "fit-content",

  },
  inputSection: {
    // display: { sx: "block", md: "flex" },
    justifyContent: "space-between",
    px: 2
  },
  inputSectionFull: {
    px: 2
  },
  permissionLine: {
    border: "1.5px solid #28AA4A",
    width: "20px",
    mx: 1,
  },
  lineTextGrid: {
    display: "flex",
    alignItems: "center",
    mx: 1,
    my:2

  },
  greyLine: {
    border: "1.5px solid #D9D9D9",
    width: "100%",
    my:2
  },


  leaveSection: {
    display: { sx: "block", md: "flex" },
    justifyContent: "space-between",
    px: 2
  },
  mainContainer: {
    px: "15px",
    display: "flex",
    mt: 2,
    justifyContent: "space-between",

  },
  uploadSection: {
    px: 2,
    width: { xs: "100%", md: "55%" },

    "& .css-13ghu1p": {
      py: "5px"

    }
  },
  printbtn: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: color.lightText,
    mr: "10px",
    // my: 4,
    fontSize: "12px",
    px: 3,

  },

  inputBox: {
    display: {xs:"block", md: "flex"},
    justifyContent: "space-between",
    alignItems: "center"
  },
  inputBoxes: {
    width: { xs: "100%", md: "33%", lg: "32%" },
  },

  inputSections: {
    display: { sx: "block", md: "flex" },
    justifyContent: "space-between",

    px: 2
  },

  // input: {
  //   width: { xs: "100%", md: "33%", lg: "32.5%" }
  // },
  downloadIcon: {
    mr: 1,
    fontSize: "4px",
  },

  inputBoxfullWidth: {
    width: "100%"
  },
  additionalBox: {
    width: { xs: "100%", md: "49%", lg: "32%" }
  },

  inputText: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mt: 1,
  },
  uploadText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.lightText,
    mt: 2,
    mb: 1,

  },
  gridbox: {
    backgroundColor: "#ffff",
    m: 2,
    py: 2,
    mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "fit-content",

  },
  gridText: {
    // mx:2,
    fontSize: "14px",
    fontWeight: "500"
  },
  bioBox: {
    px: 3,
    pt: 1,
  },
  content: {
    mt: 2,
    ml: 2,
    display: "flex",
    flexDirection: "row",
    // justifyContent:"space-Between"
  },
  switchSection: {
    display: "flex",
    alignItems: "center",
    mb: 1,
  },
  mainBoxes: {
    m: "10px",
    px: "10px",
    display: "flex",
    mb: 3,
  },
  jobButtons: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "14px",
    fontWeight: "500",
    px: 4,
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator": {
      position: "unset",
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px",
      marginLeft: "-8px",
    },
  },
  addButton: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "14px",
    fontWeight: "500",
    px: 4,
    mt: 2

  },
  cancelButtons: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#878787",
    fontSize: "14px",
    fontWeight: "500",
    ml: 3,
    px: 4,

  },


  switchKeyText: {
    width: { xs: "60%", md: "32%" }
  },
  switchContent: {
    fontSize: "12px",
    fontWeight: "500",
  },
  descText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color?.text,
  },
  descValueText: {
    fontSize: "14px",
    fontWeight: "500",
    color: color?.text,
  },
  infoSection: {
    px: 3,
  },
  bioIconText: {
    fontSize: "22px",
    fontWeight: "600",
  },
  textPrimary: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.lightText,
  },
  line: {
    border: "1px solid #D9D9D9",
    my: 2,
    mx: 3
  },
  subHeading: {
    fontSize: "16px",
    fontWeight: "600"
  },
  contactSection: {
    mt: 4,
  },

  contenttSection: {
    mt: 2.5,
  },

  durationText: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "21px",

  },
  contactSubheading: {
    fontSize: "18px",
    fontWeight: "600",

  },
  infoBox: {
    display: "flex",
    mb: 1.5,
  },
  bioText: {
    fontSize: "14px",
    fontWeight: "600",
  },
  bioTextValue: {
    fontSize: "14px",
    fontWeight: "400",
    ml: 2,

  },
  productSection: {
    px: 2,

    "& .css-2y07vr": {
      py: "7px"

    }

  },
  bioTextValueSuccess: {
    fontSize: "14px",
    fontWeight: "400",
    ml: 2,
    color: color.primary,

  },
  detailText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.text
  },
  productText: {
    fontSize: "14px",
    fontWeight: "400",
    mb: 1
  },

  closeJob: {
    color: "#FF0000",
    fontSize: "14px",
  },
  removeSection: {
    display: "flex",
    alignItem: "center",
    justifyContent: "space-between",
    mt: 2,

  },
  liText: {
    fontSize: "14px",
    listStyle: "disc !important",
    display: "list-item",
  },
  createJob: {
    textAlign: "center",
  }
};

export default style;